<script>
  import { format } from 'svelte-i18n';
  import { Offcanvas } from '@sveltestrap/sveltestrap';
  import { format as formatDate } from 'date-fns';

  // import { ActivityUserAgents } from '@client/components/activity-user-agents';
  import { Icon } from '@client/components/icon';
  import { Recipient } from '@client/components/recipient';
  import { RecipientFiltering } from '@client/components/recipient-filtering';

  import { FusionService } from '@client/services/fusion';

  import { appStore } from '@client/stores/app';

  // import { getFlag } from '@client/utils/flags';

  export let row = {};
  export let recipientFilter = null;

  let replayUrl = '';
  let currentUrl = '';
  let config = {};

  const groupByDates = (data, field) => {
    return data.reduce((acc, config) => {
      const date = formatDate(new Date(config[field]), 'M/d/yyyy');

      if (!acc[date]) {
        acc[date] = [];
      }

      acc[date].push(config);

      return acc;
    }, {});
  };

  const updateReplyUrl = (session) => {
    const url = `https://www.sendergen.com/sitesession/${session.msghashid}/${session.session}/watch.html`;

    if (currentUrl === url) {
      currentUrl = '';
      replayUrl = '';
      config = {};
      return;
    }

    config = session;
    replayUrl = url;
    currentUrl = replayUrl;
  };

  const onIframeLoad = function () {
    this.style.visibility = 'visible';
    this.style.height = (this.contentWindow.document.body.firstChild.clientHeight + 20) / 2 + 'px';
    this.style.width = (this.contentWindow.document.body.firstChild.clientWidth + 20) / 2 + 'px';
  };

  $: recipients = Object.entries(row.recips).filter(
    ([, email]) => (recipientFilter && email === recipientFilter) || !recipientFilter
  );
</script>

{#key recipientFilter}
  <RecipientFiltering bind:recipient={recipientFilter}>
    {@html $format('label.TRACKING_RECIPIENT_FILTERING', { values: { filter: recipientFilter } })}
  </RecipientFiltering>

  <div class="fusion-layout">
    <div class="sessions">
      {#each recipients as [msghashid, email]}
        <div class="recipient-history">
          <Recipient recipient={email} history={[]} />
          {#await FusionService.getAll({ msghashid })}
            <div class="empty">{$format('label.LOADING_REPLAY_HISTORY')}</div>
          {:then sessions}
            {#if !sessions.length}
              <div class="empty">{$format('label.NO_REPLAY_HISTORY_AVAVLIABLE')}</div>
            {:else}
              {#each Object.entries(groupByDates(sessions, 'session')) as [date, entries]}
                <div class="day-block">
                  <div class="date">{formatDate(new Date(date), 'EEEE, MMM d, yyyy')}</div>
                  <div class="timeline">
                    {#each entries as session}
                      <div
                        class="item"
                        role="button"
                        tabindex="0"
                        on:click={() => updateReplyUrl(session)}
                        class:active={currentUrl ===
                          `https://www.sendergen.com/sitesession/${session.msghashid}/${session.session}/watch.html`}
                      >
                        <div class="icon">
                          <i
                            class:os-icon-play-circle={currentUrl !== `${session.msghashid}${session.session}`}
                            class:os-icon-pause-circle={currentUrl === `${session.msghashid}${session.session}`}
                          />
                        </div>
                        <div class="time">
                          {formatDate(new Date(session.session), 'h:mm:ss aa')}
                          <small>{formatDate(session.maxts - session.session, 'mm:ss')}</small>
                        </div>
                        <div class="details">
                          <div class="page-title">{session.site.page_title}</div>
                          <small class="page-url">
                            <a href={session.site.page_url} target="_blank">
                              {session.site.page_url}
                            </a>
                          </small>
                          <a
                            href="https://www.sendergen.com/sitesession/{session.msghashid}/{session.session}/watch.html"
                            target="_blank"
                            class="external-link"
                          >
                            <Icon name="external-link" />
                          </a>

                          <!-- {#if session?.user?.userAgent}
                            <div>
                              <small class="user-location">
                                <ActivityUserAgents ua={session.user.userAgent} />
                              </small>
                            </div>
                          {/if} -->
                        </div>
                      </div>
                    {/each}
                  </div>
                </div>
              {/each}
            {/if}
          {:catch}
            <div class="empty">{$format('label.NO_REPLAY_HISTORY_AVAVLIABLE')}</div>
          {/await}
        </div>
      {/each}
    </div>
    {#if $appStore.mobile}
      {#if currentUrl}
        <Offcanvas
          class="activity-offcanvas"
          isOpen={currentUrl}
          toggle={() => updateReplyUrl(config)}
          placement="end"
          style="width: 98%"
        >
          <div slot="header" class="offcanvas-heading">
            <Icon name="video" />
            <span>{config.site.page_title}</span>
          </div>
          <div class="offcanvas-playback">
            {#if replayUrl}
              {#key replayUrl}
                <iframe
                  tabindex="-1"
                  style="visibility: hidden;"
                  title="preview"
                  on:load={onIframeLoad}
                  src={replayUrl}
                />
              {/key}
            {:else}
              <div class="empty-player">{$format('label.SLIDE_ANALYTICS_SELECT_SESSION')}</div>
            {/if}
          </div>
        </Offcanvas>
      {/if}
    {:else}
      <div class="iframe">
        {#if replayUrl}
          {#key replayUrl}
            <iframe tabindex="-1" style="visibility: hidden;" title="preview" on:load={onIframeLoad} src={replayUrl} />
          {/key}
        {:else}
          <div class="empty-player">{$format('label.SLIDE_ANALYTICS_SELECT_SESSION')}</div>
        {/if}
      </div>
    {/if}
  </div>
{/key}

<style lang="scss" src="./website-tracking.scss"></style>
